import { Injectable } from '@angular/core';
import Quill from 'quill';
import { BlockquoteInlineStyle } from './blockquote-inline.class';
import { QuillEditorHelperConfigModel } from './quill-editor-helper-config.model';
import { InlineMarginParagraphs, InlineMarginHeaders, InlineMarginLists } from './inline-margin-styles.class';
@Injectable()
export class QuillEditorHelperService {
  mergeVariables = [
    ['Student Full Name', '<<%Student Name%>>'],
    ['Student First Name', '<<%FirstName%>>'],
    ['Student Last Name', '<<%LastName%>>'],
    ['Zip', '<<%ZipCode%>>'],
    ['Client Number', '<<%AccountId%>>'],
    ['Graduation Year', '<<%GraduationYear%>>'],
    ['Parent Full Name', '<<%ParentName%>>'],
    ['Student Email Address', '<<%EmailId%>>'],
    ['Parent Email Address', '<<%ParentEmailId%>>']
  ];

  companyMergeVariables = [
    ['Company Phone Number', '<<%CompanyPhone%>>'],
    ['Company Fax Number', '<<%CompanyFax%>>'],
    ['Company Logo', '<<%CompanyLogo%>>'],
    ['Company Name', '<<%CompanyName%>>']
  ];

  constructor() {
    const colorAttr = Quill.import('attributors/class/color');
    const sizeAttr = Quill.import('attributors/style/size');
    sizeAttr.whitelist = ['0.75em', '1.5em', '2.5em'];
    const alignAttr = Quill.import('attributors/style/align');
    const fontAttr = Quill.import('attributors/style/font');
    const directionAttr = Quill.import('attributors/style/direction');
    Quill.register(colorAttr, true);
    Quill.register(alignAttr, true);
    Quill.register(fontAttr, true);
    Quill.register(directionAttr, true);
    Quill.register(BlockquoteInlineStyle, true);
    Quill.register(sizeAttr, true);
    Quill.register(InlineMarginParagraphs, true);
    Quill.register(InlineMarginHeaders, true);
    Quill.register(InlineMarginLists, true);
  }

  getQuillModules(config?: QuillEditorHelperConfigModel) {
    config = config || {needCompanyVars: false, needMergeVars: false};
    const quillModules: any = {
      toolbar: {
        container:
          [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
            ['blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],               // custom button values
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
            [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
            [{ 'direction': 'rtl' }],                         // text direction
            [{ 'size': ['0.75em', false, '1.5em', '2.5em'] }],  // custom dropdown
            [{ 'header': [1, 2, 3, 4, 5, 6] }],
            [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
            [{ 'font': [] }],
            [{ 'align': [] }],
            ['clean'],
            ['link', 'image', 'video'], //'image', 'video'                                // remove formatting button

          ]
      }
    };
    if (config.needMergeVars) {
      let mergeVars = this.mergeVariables.slice();
      if (config.needCompanyVars) {
        mergeVars = [...this.companyMergeVariables, ...mergeVars];
      }
      quillModules.toolbar.container.push([{ 'placeholder': mergeVars.map(mergeVar => mergeVar[0]) }]);
      quillModules.toolbar.handlers = {
        placeholder: function(value) {
          if (value) {
            const cursorPosition = this.quill.getSelection().index;
            const neededVar = mergeVars.find(label => label[0] === value)[1];
            this.quill.insertText(cursorPosition, neededVar);
            this.quill.setSelection(cursorPosition + value.length);
          }
        }
      }
    }
    return quillModules
  }
}
